import * as React from 'react';
import { TextInput, IntInput } from 'components/widgets/TextInput';
import { observable } from 'mobx';
import { Button } from 'components/widgets/Button';
import { closePopup } from '../../widgets/Popup';
import { StringFunc } from 'types/types';
import { IconFactory, Icon } from 'components/widgets/icons';
import { observer } from 'mobx-react';
import { TrackersData } from 'data/TrackersData';

import './CreateTrackerPopup.pcss';
import { ErrorMessage } from 'components/widgets/ErrorMessage';

@observer
export class CreateTrackerPopup extends React.Component {

  @observable name:string;
  @observable iconName:string;
  @observable dailyGoal:number;
  @observable unit:string;

  @observable saving:boolean = false;
  @observable error:boolean = false;
  @observable errorMessage:string; 
  @observable errorTitle:string;

  handleAddClick = () => {
    
    if( !this.name || this.name.trim().length==0 ||
    !this.iconName || this.iconName.trim().length==0 ||
    !this.unit || this.unit.trim().length==0 ||
    !this.dailyGoal) {
      this.errorTitle = "Oops!"
      this.errorMessage = "All fields are required.";
      this.error = true;
      this.saving = false;
    } else {

      if(this.name.trim().length==0) { this.name = 'my tracker'; } 
      if(this.iconName.trim().length==0) { this.iconName = IconFactory.customIcons.CARROT; } 
      if(this.unit.trim().length==0) { this.unit = 'unit'; } 
      if(this.dailyGoal<0) { this.dailyGoal = 1; };

      this.error = false;
      TrackersData.createCustomTracker(this.name, this.iconName, this.dailyGoal, this.unit)
      .then(()=>{
        closePopup();
      })
      .catch(()=>{
        this.errorTitle = "Add Failed"
        this.errorMessage = "Failed to add your custom tracker. Please make sure that your Internet connection is stable and try again.";
        this.error = true;
        this.saving = false;
      });
    }
  }

  render() {
    
    return (
      <div className="trackerPopup create">
        {this.error ?
        <React.Fragment>
          <h1>Create Tracker</h1>
          <div className="popupBody">
            <ErrorMessage message={this.errorMessage} title={this.errorTitle} />
          </div>
          <div className="popupFooter">
            <Button flat onClick={()=>{ this.error = false; }}>Got it!</Button>
          </div>
        </React.Fragment>
        :
        <React.Fragment>
          <h1>Create Tracker</h1>
          <div className="popupBody">
          
            <h2>Name your custom tracker</h2>
            <InputLabel label="Name">
              <TextInput onChangeValue={(v)=>{ this.name = v; }} value={this.name} disabled={this.saving} placeholder={'enter'} />
            </InputLabel>

            <hr/>

            <h2>Choose an Icon</h2>
        
            <IconChoices iconName={this.iconName} onSelectIcon={(iconName)=>{ this.iconName = iconName;}} />

            <hr style={{marginTop:'0'}}/>

            <h2>Set your daily goal and unit</h2>
            <p>For example 5 servings of vegetables. Enter a goal of "5" and a unit of "serving". Another example could be limiting yourself 
              to 2 cups of coffee a day. Enter a goal/limit of "2" and a unit of "cup".</p>
            <InputLabel label="Goal/Limit">
              <IntInput onChangeValue={(v)=>{ this.dailyGoal = v; }} value={this.dailyGoal} disabled={this.saving} placeholder={'enter'} />
            </InputLabel>          
            <InputLabel label="Unit">
              <TextInput onChangeValue={(v)=>{ this.unit = v; }} value={this.unit} disabled={this.saving} placeholder={'enter'} />
              <span className="hint">singular, i.e. - 'cup'</span>
            </InputLabel>

          </div>
          <div className="popupFooter">
            <Button onClick={this.handleAddClick}>Add</Button>
            <Button cancel flat onClick={closePopup}>Cancel</Button>
          </div>
        </React.Fragment>
        }
      </div>
    );   
  }

} 

interface IconChoices_P {
  iconName:string;
  onSelectIcon:StringFunc;
}

@observer
class IconChoices extends React.Component<IconChoices_P> {
  render() {
    return (
      <div className="iconChoices">
        {IconFactory.customIconList.map((icon, idx)=><IconChoice key={icon} iconName={icon} selectedIconName={this.props.iconName} onSelectIcon={this.props.onSelectIcon} />)}   
      </div>
    );
  }
}

interface IconChoice_P {
  iconName:string;
  selectedIconName:string;
  onSelectIcon:StringFunc;
}
const IconChoice = (props:IconChoice_P) => 
  <div className={`iconChoice${props.iconName===props.selectedIconName?' selected':''} noselect`} onClick={()=>{ props.onSelectIcon(props.iconName); }}>
    <Icon iconName={props.iconName} color="#666666"/>
  </div>
;


const InputLabel = (props:{label:string, children:any}) =>
  <div className="inputLabel">
    <label>{props.label}</label>
    {props.children}
  </div>
;